import { IOfferCard } from '../../../types/card';

export function isFlat(offerCard: IOfferCard): boolean {
  return offerCard.offerType === 'flat';
}
